import type { RouteRecordRaw } from 'vue-router'

const homeRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.home' },
    component: () => import('@/pages/home/HomePage.vue'),
  },
  {
    path: '/campaign/:id',
    name: 'campaign-detail',
    meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.home' },
    component: () => import('@/pages/home/CampaignDetailPage.vue'),
  },
  {
    path: '/campaign/:id/preview',
    name: 'campaign-preview',
    meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.home' },
    component: () => import('@/pages/home/CampaignPreviewPage.vue'),
  },
  {
    path: '/calls/direct',
    alias: '/calls/select-campaign',
    name: 'direct-call',
    meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.home' },
    component: () => import('@/pages/home/CampaignDetailPage.vue'),
  },
]

export default homeRoutes
